
/* injects from baggage-loader */

'use strict';

import notFoundTemplate from '!!file-loader?name=templates/[name].[ext]!./notFound.html';

/**
 * Function that register the all routes for the not found module.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @param {any} routerHelper
 */
function routeRun($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	 * Route definition of the notFound page.
	 */
	const indexNav = 3;
	const notFoundRoute = {
		state: navigationConstant.RESOURCES[indexNav].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].URL,
			templateUrl: notFoundTemplate,
			controller: 'NotFoundController',
			controllerAs: 'notFoundvm',
			resolve: {
				notFound: notFoundLazyLoading
			},
				data: {
					code: navigationConstant.RESOURCES[indexNav].CODE,
					login: false,
					pageTitle: navigationConstant.RESOURCES[indexNav].NAME,
					submenu: false
			},
		}
	};

	routerHelper.configureStates([notFoundRoute]);
}

/**
 * Function for the lazyLoading configuration in the not found route.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @returns
 */
function notFoundLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const notFoundModule = require('./notFound.module');

		$ocLazyLoad.load({
			name: notFoundModule.default.name,
		});

		deferred.resolve(notFoundModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('notFound.routes', [])
	.run(routeRun);



// WEBPACK FOOTER //
// ./src/app/core/components/notFound/notFound.routes.js